import React, { useContext, useEffect, useRef, useState } from "react";
import "./Television.css";
import { Context } from "../../context/Context";
import {
  CreateEquipmentButton,
  DeleteEquipments,
  UpdateEquipments,
} from "../../api/api";
import ErrorToast from "../toasts/ErrorToast";
import { Link, useNavigate, useParams } from "react-router-dom";
import { MqttContext } from "../../context/MQTTContext";
import SuccessToast from "../toasts/SuccessToast";
import WarningAlert from "../sweeAlerts/WarningAlert";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import NumbersModal from "../modals/NumbersModal";

const Television = ({ equipment_id }) => {
  const {
    handleNumbersModal,
    handleLearnCodeModal,
    setButtonShouldLearnCode,
    update,
    setTvButtons,
    clickTvButton,
    setClickTvButton,
    authUser,
    setIsLoading,
    equipmentButtons,
    setEquipmentButtons,
    devices,
    equipments,
    setEquipments,
    handleEquipmentsListModal,
    setSelectedEquipment,
    handleChangeNameModal,
    setChangeNameOptions,
    currentRoom,
    selectedEquipment,
  } = useContext(Context);
  const { clients } = useContext(MqttContext);
  const [buttons, setButtons] = useState([]);
  const [selectedIcon, setSelectedIcon] = useState("");
  const [deviceId, setDeviceId] = useState();
  const [learningModeInTv, setLearningModeInTv] = useState(false);
  const [editEquipmentName, setEditEquipmentName] = useState(false);
  const [editedEquipmentName, setEditedEquipmentName] = useState("");

  const navigate = useNavigate();

  const { equipment_id: eq_id, room_id, equipment_type: eq_type } = useParams();

  useEffect(() => {
    if (!equipmentButtons.length) return;
    setDeviceId(
      equipmentButtons.find((eq_btn) => eq_btn.equipment_id == eq_id)
        ?.device_id,
    );
    setButtons(
      equipmentButtons
        .filter((eq_btn) => eq_btn.equipment_id == eq_id)
        .map((btn) => ({
          ...btn,
          digit: btn.digit != null ? Number(btn.digit) : null,
        })),
    );
    // setTvButtons(
    //   equipmentButtons.filter((eq_btn) => eq_btn.equipment_id == eq_id).map(btn => ({
    //     ...btn,
    //     digit: btn.digit != null ? Number(btn.digit) : null
    //   }))
    // );
    setSelectedEquipment({
      id: eq_id,
      type: eq_type,
    });
  }, [update, equipmentButtons, eq_id]);

  const concatenateStringAndBuffer = (str, buffer) => {
    let encoder = new TextEncoder();
    let encodedString = encoder.encode(str); // تبدیل رشته به بایت‌ها

    // ساخت یک بافر جدید که به اندازه رشته و بافر اصلی است
    let newBuffer = new Uint8Array(encodedString.length + buffer.byteLength);

    // قرار دادن رشته در ابتدا
    newBuffer.set(encodedString, 0);

    // قرار دادن بافر در ادامه
    newBuffer.set(new Uint8Array(buffer), encodedString.length);

    return newBuffer;
  };

  const handleClickButton = (digit, icon) => {
    let button = buttons.find((b) => b.digit == digit);
    if (
      button &&
      button.data1 != null &&
      button.data2 != null &&
      button.data3 != null &&
      button.data4 != null &&
      button.data5 != null &&
      !learningModeInTv
    ) {
      let device = devices.find((d) => d.id == button.device_id);
      if (!device) {
        return ErrorToast("دستگاه ناشناخته می باشد");
      }
      setClickTvButton(true);
      if (device.is_bus && clients[device?.bridge_device?.id]) {
        let buffer = new ArrayBuffer(15);
        let asciiCode = new Uint8Array(buffer);
        asciiCode[0] = 14;
        asciiCode[1] = `${device.serial[0]}`.charCodeAt(0);
        asciiCode[2] = `${device.serial[1]}`.charCodeAt(0);
        asciiCode[3] = `${device.serial[2]}`.charCodeAt(0);
        asciiCode[4] = `${device.serial[3]}`.charCodeAt(0);
        asciiCode[5] = `${device.serial[4]}`.charCodeAt(0);
        asciiCode[6] = `${device.serial[5]}`.charCodeAt(0);
        asciiCode[7] = device.type + 50;
        asciiCode[8] = 1;
        asciiCode[9] = 5;
        asciiCode[10] = button.data1;
        asciiCode[11] = button.data2;
        asciiCode[12] = button.data3;
        asciiCode[13] = button.data4;
        asciiCode[14] = button.data5;

        let message = device.bridge_device.internet_token;

        // ترکیب رشته و بافر
        let combinedMessage = concatenateStringAndBuffer(message, asciiCode);

        const messageListener = (topic, message) => {
          const endOfTwoCharToken =
            String.fromCharCode(message[0]) + String.fromCharCode(message[1]);
          const deviceSerial =
            String.fromCharCode(message[3]) +
            String.fromCharCode(message[4]) +
            String.fromCharCode(message[5]) +
            String.fromCharCode(message[6]) +
            String.fromCharCode(message[7]) +
            String.fromCharCode(message[8]);
          if (
            device.bridge_device.internet_token.slice(-2) ===
              endOfTwoCharToken &&
            device.serial === deviceSerial &&
            message[10] == 1 &&
            message[2] == 14
          ) {
            setClickTvButton(false);
          }
        };
        clients[device.bridge_device.id].removeAllListeners("message");
        clients[device.bridge_device.id].on("message", messageListener);
        clients[device.bridge_device.id].publish(
          device.bridge_device.serial + "/sys",
          combinedMessage,
        );
      } else if (
        device.id &&
        device.username &&
        device.password &&
        clients[device.id]
      ) {
        let buffer = new ArrayBuffer(7);
        let asciiCode = new Uint8Array(buffer);
        asciiCode[0] = 1;
        asciiCode[1] = 5;
        asciiCode[2] = button.data1;
        asciiCode[3] = button.data2;
        asciiCode[4] = button.data3;
        asciiCode[5] = button.data4;
        asciiCode[6] = button.data5;

        let message = device.internet_token;

        // ترکیب رشته و بافر
        let combinedMessage = concatenateStringAndBuffer(message, asciiCode);

        const messageListener = (topic, message) => {
          const endOfTwoCharToken =
            String.fromCharCode(message[0]) + String.fromCharCode(message[1]);
          if (
            device.internet_token.slice(-2) === endOfTwoCharToken &&
            message[2] == 1 &&
            message[3] == 0
          ) {
            setClickTvButton(false);
          }
        };

        clients[device.id].removeAllListeners("message");
        clients[device.id].on("message", messageListener);

        clients[device.id].publish(device.serial + "/sys", combinedMessage);
      }
    } else {
      setIsLoading(true);
      CreateEquipmentButton({
        equipment_id: eq_id,
        device_id: deviceId,
        digit: `${digit}`,
        type: 100,
      }).then(({ data }) => {
        setEquipmentButtons((prev) => [
          ...prev,
          {
            id: data.equipment_button
              ? data.equipment_button.id
              : data.equipment_buttons[0].id,
            equipment_id: eq_id,
            device_id: deviceId,
            digit: digit,
            type: 100,
            data1: null,
            data2: null,
            data3: null,
            data4: null,
            data5: null,
          },
        ]);
        setButtonShouldLearnCode(data.equipment_button);
        handleLearnCodeModal(true);
        setIsLoading(false);
        setLearningModeInTv(false);
      });
    }
  };

  const handleChangeEquipmentName = (equipment_id) => {
    const onSubmitFunc = ({ equipment_id, name }) => {
      UpdateEquipments({
        equipment_id,
        name,
      }).then((res) => {
        const updatedEquipments = equipments.map((item) =>
          item.id == equipment_id
            ? {
                ...item,
                equipment: { ...item.equipment, name: name },
              }
            : item,
        );
        setEquipments(updatedEquipments);
      });
    };
    const newOptions = {
      name:
        equipments.find((eq) => eq.id == equipment_id)?.equipment.name ?? "",
      onSubmit: (newName) => {
        onSubmitFunc({ equipment_id, name: newName });
      },
    };
    setChangeNameOptions(newOptions);
    handleChangeNameModal();
  };
  const handleRemoveEquipment = (equipment_id) => {
    WarningAlert(
      "آیا از حذف این تجهیز اطمینان دارید؟",
      "",
      "تایید",
      "انصراف",
    ).then(function (result) {
      if (result.value) {
        DeleteEquipments({ equipment_id }).then((res) => {
          SuccessToast(res.data.message);
          let newEquipments = equipments.filter((eq) => eq.id != equipment_id);
          setEquipments(newEquipments);
          let lstEquipment = newEquipments.find(
            (eq) => eq.room_id == currentRoom,
          );
          handleEquipment(lstEquipment, currentRoom);
        });
      }
    });
  };

  const handleEquipment = (equipment, roomId) => {
    if (!equipment) return navigate("/room/" + roomId);
    equipment = equipment.equipment;
    setSelectedEquipment({
      id: equipment.id,
      type: equipment.type,
    });
    if (!equipment) {
      return navigate("/");
    } else if (equipment.type == 1) {
      return navigate(
        "/room/key/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 3) {
      return navigate(
        "/room/remote/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 4) {
      return navigate(
        "/room/dimmer/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 5) {
      return navigate(
        "/room/thermostat/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 9) {
      return navigate(
        "/room/rgb/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 99) {
      return navigate(
        "/room/wireless-key/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 100) {
      return navigate(
        "/room/television/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 501) {
      return navigate(
        "/room/fan-coil/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 401) {
      return navigate(
        "/room/scenario-key/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 503) {
      return navigate(
        "/room/humidity/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 502) {
      return navigate(
        "/room/motor/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 9998) {
      return navigate(
        "/room/input/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 9999) {
      return navigate(
        "/room/input-status/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 600) {
      return navigate(
        "/room/data-logger/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    }
  };

  return (
    <div
      className="card h-100"
      style={{ backgroundColor: "#fff0", boxShadow: "none" }}
    >
      <div
        className="card-header d-flex align-items-center justify-content-between border-bottom mb-3 p-0 pt-2"
        style={{ zIndex: "1" }}
      >
        <h5 className={editEquipmentName ? "d-none" : ""}>
          {equipments.find((eq) => eq.id == eq_id)?.equipment?.name ?? ""}
        </h5>
        <div
          className={editEquipmentName ? "mt-2 d-block" : "d-none"}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          <div>
            <input
              id="smallInput"
              className="form-control form-control-sm text-center"
              name="room_name"
              type="text"
              placeholder="نام تجهیز را وارد کنید"
              value={editedEquipmentName}
              onChange={(e) => setEditedEquipmentName(e.target.value)}
            />
          </div>
          <div className="mt-1">
            <button
              type="button"
              className="btn btn-xs btn-success-app submit-add-room me-2"
              onClick={() =>
                handleChangeEquipmentName(
                  equipments.find((eq) => eq.id == eq_id)?.id,
                )
              }
            >
              ثبت
            </button>
            <button
              type="button"
              className="btn btn-xs btn-success-app"
              onClick={(e) => setEditEquipmentName(false)}
            >
              انصراف
            </button>
          </div>
        </div>
        <div>
          {authUser.is_admin ? (
            <>
              <button
                type="button"
                className="btn btn-success-app btn-icon me-2"
                style={{ borderColor: "rgb(0, 165, 148)" }}
                onClick={() => handleRemoveEquipment(selectedEquipment.id)}
              >
                <i className="bx bx-trash"></i>
              </button>
              <div className="btn-group">
                <button
                  type="button"
                  className="btn btn-success-app btn-icon dropdown-toggle hide-arrow"
                  style={{ borderColor: "rgb(0, 165, 148)" }}
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="bx bx-dots-vertical-rounded"></i>
                </button>
                <ul className="dropdown-menu dropdown-menu-end">
                  <li>
                    <Link
                      className="dropdown-item"
                      onClick={(e) => {
                        e.preventDefault();
                        handleEquipmentsListModal(true);
                      }}
                    >
                      افزدون تجهیز
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      to={
                        "/room/select-device/" +
                        room_id +
                        "/" +
                        eq_id +
                        "/" +
                        eq_type
                      }
                    >
                      افزدون کانال به تجهیز
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      onClick={(e) => {
                        e.preventDefault();
                        handleChangeEquipmentName(
                          equipments.find((eq) => eq.id == eq_id)?.id,
                        );
                      }}
                    >
                      تغییر نام تجهیز
                    </Link>
                  </li>
                </ul>
              </div>
            </>
          ) : null}

          {/* <BackButton url={"/room/" + room_id} /> */}
        </div>
      </div>
      <div
        className={
          devices.find((d) => d.id == buttons?.[0]?.device_id)
            ? "card-body scrollbar"
            : "d-none"
        }
        style={{ paddingBottom: "10rem" }}
      >
        {/* <SimpleBar style={{ maxHeight: "100%", padding: "1.5rem" }}> */}
        <div
          className="keys rounded-3"
          style={{
            boxShadow: clickTvButton
              ? "0 0.25rem 1rem rgba(0, 122, 255, 0.45)"
              : "",
          }}
        >
          {authUser.is_admin ? (
            <div className="d-flex flex-nowrap justify-content-between">
              <div className="btn-group">
                <button
                  type="button"
                  className="btn btn-icon rounded-pill dropdown-toggle hide-arrow"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="bx bx-dots-vertical-rounded"></i>
                </button>
                <ul className="dropdown-menu ">
                  <li onClick={() => setLearningModeInTv(!learningModeInTv)}>
                    <a
                      className={
                        learningModeInTv
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                    >
                      یادگیری مجدد
                    </a>
                  </li>
                </ul>
              </div>
              <p className="text-center m-0 mb-3" style={{ fontSize: "11px" }}>
                S/
                {devices.find((d) => d.id == buttons?.[0]?.device_id)?.serial}
              </p>
            </div>
          ) : null}
          <div className="d-flex justify-content-around">
            <div
              className="top-keys"
              onClick={() => handleClickButton(2, "kd.png")}
            >
              <img
                src={
                  buttons.some(
                    (button) =>
                      button.digit == 2 &&
                      button.data1 != null &&
                      button.data2 != null &&
                      button.data3 != null &&
                      button.data4 != null &&
                      button.data5 != null,
                  )
                    ? "/assets/img/app-icons/kd-on.png"
                    : "/assets/img/app-icons/kd.png"
                }
              />
            </div>
            <div
              className="top-keys"
              onClick={() => handleClickButton(1, "Lk.png")}
            >
              <img
                src={
                  buttons.some(
                    (button) =>
                      button.digit == 1 &&
                      button.data1 != null &&
                      button.data2 != null &&
                      button.data3 != null &&
                      button.data4 != null &&
                      button.data5 != null,
                  )
                    ? "/assets/img/app-icons/Lk-on.png"
                    : "/assets/img/app-icons/Lk.png"
                }
              />
            </div>
            <div
              className="top-keys"
              onClick={() => handleClickButton(0, "df.png")}
            >
              <img
                src={
                  buttons.some(
                    (button) =>
                      button.digit == 0 &&
                      button.data1 != null &&
                      button.data2 != null &&
                      button.data3 != null &&
                      button.data4 != null &&
                      button.data5 != null,
                  )
                    ? "/assets/img/app-icons/df-on.png"
                    : "/assets/img/app-icons/df.png"
                }
              />
            </div>
          </div>
          <div className="center-keys">
            <div
              className="position-absolute"
              style={{ top: "12px", right: "calc(50% - 3px)" }}
              onClick={() => handleClickButton(3, "mU1.png")}
            >
              <img
                src={
                  buttons.some(
                    (button) =>
                      button.digit == 3 &&
                      button.data1 != null &&
                      button.data2 != null &&
                      button.data3 != null &&
                      button.data4 != null &&
                      button.data5 != null,
                  )
                    ? "/assets/img/app-icons/mU1-on.png"
                    : "/assets/img/app-icons/mU1.png"
                }
                style={{ width: "6px" }}
              />
            </div>
            <div
              className="position-absolute"
              style={{ top: "calc(50% - 12px)", right: "15px" }}
              onClick={() => handleClickButton(6, "mU1.png")}
            >
              <img
                src={
                  buttons.some(
                    (button) =>
                      button.digit == 6 &&
                      button.data1 != null &&
                      button.data2 != null &&
                      button.data3 != null &&
                      button.data4 != null &&
                      button.data5 != null,
                  )
                    ? "/assets/img/app-icons/mU1-on.png"
                    : "/assets/img/app-icons/mU1.png"
                }
                style={{ width: "6px" }}
              />
            </div>
            <div
              className="position-absolute"
              style={{ top: "calc(50% - 12px)", left: "15px" }}
              onClick={() => handleClickButton(4, "mU1.png")}
            >
              <img
                src={
                  buttons.some(
                    (button) =>
                      button.digit == 4 &&
                      button.data1 != null &&
                      button.data2 != null &&
                      button.data3 != null &&
                      button.data4 != null &&
                      button.data5 != null,
                  )
                    ? "/assets/img/app-icons/mU1-on.png"
                    : "/assets/img/app-icons/mU1.png"
                }
                style={{ width: "6px" }}
              />
            </div>
            <div
              className="position-absolute"
              style={{
                top: "calc(50% - 30px)",
                right: "calc(50% - 30px)",
                backgroundColor: "rgb(221, 221, 221)",
                borderRadius: "50%",
              }}
              onClick={() => handleClickButton(5, "Aq.png")}
            >
              <img
                src={
                  buttons.some(
                    (button) =>
                      button.digit == 5 &&
                      button.data1 != null &&
                      button.data2 != null &&
                      button.data3 != null &&
                      button.data4 != null &&
                      button.data5 != null,
                  )
                    ? "/assets/img/app-icons/Aq-on.png"
                    : "/assets/img/app-icons/Aq.png"
                }
                style={{ width: "60px" }}
              />
            </div>
            <div
              className="position-absolute"
              style={{ bottom: "12px", right: "calc(50% - 3px)" }}
              onClick={() => handleClickButton(7, "mU1.png")}
            >
              <img
                src={
                  buttons.some(
                    (button) =>
                      button.digit == 7 &&
                      button.data1 != null &&
                      button.data2 != null &&
                      button.data3 != null &&
                      button.data4 != null &&
                      button.data5 != null,
                  )
                    ? "/assets/img/app-icons/mU1-on.png"
                    : "/assets/img/app-icons/mU1.png"
                }
                style={{ width: "6px" }}
              />
            </div>
          </div>

          <div className="bottom-keys d-flex justify-content-between">
            <div onClick={() => handleClickButton(9, "16.png")}>
              <img
                src={
                  buttons.some(
                    (button) =>
                      button.digit == 9 &&
                      button.data1 != null &&
                      button.data2 != null &&
                      button.data3 != null &&
                      button.data4 != null &&
                      button.data5 != null,
                  )
                    ? "/assets/img/app-icons/16-on.png"
                    : "/assets/img/app-icons/16.png"
                }
              />
            </div>
            <div onClick={() => handleClickButton(8, "uF.png")}>
              <img
                src={
                  buttons.some(
                    (button) =>
                      button.digit == 8 &&
                      button.data1 != null &&
                      button.data2 != null &&
                      button.data3 != null &&
                      button.data4 != null &&
                      button.data5 != null,
                  )
                    ? "/assets/img/app-icons/uF-on.png"
                    : "/assets/img/app-icons/uF.png"
                }
              />
            </div>
          </div>

          <div className="bottom-keys d-flex justify-content-between">
            <div onClick={() => handleClickButton(14, "FF.png")}>
              <img
                src={
                  buttons.some(
                    (button) =>
                      button.digit == 14 &&
                      button.data1 != null &&
                      button.data2 != null &&
                      button.data3 != null &&
                      button.data4 != null &&
                      button.data5 != null,
                  )
                    ? "/assets/img/app-icons/FF-on.png"
                    : "/assets/img/app-icons/FF.png"
                }
              />
            </div>
            <div onClick={() => handleClickButton(13, "hI.png")}>
              <img
                src={
                  buttons.some(
                    (button) =>
                      button.digit == 13 &&
                      button.data1 != null &&
                      button.data2 != null &&
                      button.data3 != null &&
                      button.data4 != null &&
                      button.data5 != null,
                  )
                    ? "/assets/img/app-icons/hI-on.png"
                    : "/assets/img/app-icons/hI.png"
                }
              />
            </div>
          </div>

          <div className="d-flex justify-content-around">
            <div
              className="end-keys"
              onClick={() => handleClickButton(11, "7u.png")}
            >
              <img
                src={
                  buttons.some(
                    (button) =>
                      button.digit == 11 &&
                      button.data1 != null &&
                      button.data2 != null &&
                      button.data3 != null &&
                      button.data4 != null &&
                      button.data5 != null,
                  )
                    ? "/assets/img/app-icons/7u-on.png"
                    : "/assets/img/app-icons/7u.png"
                }
              />
            </div>
            <div
              className="end-keys"
              onClick={(status) => handleNumbersModal(true)}
            >
              <img src="/assets/img/app-icons/bk.png" />
            </div>
            <div
              className="end-keys"
              onClick={() => handleClickButton(10, "ew.png")}
            >
              <img
                src={
                  buttons.some(
                    (button) =>
                      button.digit == 10 &&
                      button.data1 != null &&
                      button.data2 != null &&
                      button.data3 != null &&
                      button.data4 != null &&
                      button.data5 != null,
                  )
                    ? "/assets/img/app-icons/ew-on.png"
                    : "/assets/img/app-icons/ew.png"
                }
              />
            </div>
          </div>
        </div>
        {/* </SimpleBar> */}
      </div>
      <NumbersModal
        type={1}
        learningModeInTv={learningModeInTv}
        setLearningModeInTv={setLearningModeInTv}
        equip_id={eq_id}
      />
    </div>
  );
};

export default React.memo(Television);
